import { render, staticRenderFns } from "./QnA.vue?vue&type=template&id=f71850a2&"
var script = {}
import style0 from "./QnA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports